"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTableData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const strings_1 = require("../../../../constants/strings");
const codingQuery_1 = require("../../../../queries/codingQuery");
const zustandStore_1 = require("../../../../zustandStore");
const logger = (0, pino_1.default)();
let initialCodingEntryId = '';
let initialCodingEntryPath = '';
const useGetTableData = ({ selectedCodingEntries }) => {
    const { setNotification } = (0, zustandStore_1.useZustand)();
    const selectedCodingList = (0, zustandStore_1.useZustand)(state => state.codingList.currentCodingListSelected);
    const changeCodingListEntryId = (0, codingQuery_1.useChangeCodingListEntryIdQuery)();
    const toggleCodingListEntryQuery = (0, codingQuery_1.useToggleCodingListEntryQuery)();
    const saveCodingListEntry = (0, codingQuery_1.useSaveCodingListEntryQuery)();
    const company = (0, zustandStore_1.useZustand)(state => state.company);
    const currentCodingEntryTeam = (0, zustandStore_1.useZustand)(state => state.user.userSelectedTeam);
    const [isMutationInProgress, setIsMutationInProgress] = (0, react_1.useState)(false);
    const { data: codingInactiveListEntries = [] } = (0, codingQuery_1.useGetInactiveCodingListEntriesQuery)({
        companyId: company?.companyId,
    });
    const selectedCodingEntriesValues = structuredClone(selectedCodingEntries) || [
        { code: '', values: [{ Id: '', path: '' }] },
    ];
    const inactiveEntries = codingInactiveListEntries[selectedCodingList.id]?.filter(obj => obj.team_id === currentCodingEntryTeam);
    return [
        selectedCodingEntriesValues.map((entry, index) => {
            const currentSelectedEntryValue = structuredClone(selectedCodingEntriesValues[index]);
            return {
                id: `${entry.ID}${index}`,
                entryId: {
                    text: entry.ID,
                    onFocus(event) {
                        // save current entry before changing
                        initialCodingEntryId = entry.ID;
                        if (!currentSelectedEntryValue) {
                            return;
                        }
                        currentSelectedEntryValue.ID = event.target.value;
                    },
                    onBlur(event) {
                        if (event.target.value === initialCodingEntryId) {
                            initialCodingEntryId = '';
                            return;
                        }
                        else if (selectedCodingEntries.some(entry => entry.ID === event.target.value)) {
                            const warningMessage = strings_1.companySettingsCodingStrings.CODING_ENTRY_DUPLICATE_ERROR({
                                entryId: event.target.value,
                            });
                            setNotification([
                                {
                                    type: strings_1.notificationStrings.WARNING,
                                    message: warningMessage,
                                },
                            ]);
                            return;
                        }
                        setIsMutationInProgress(true);
                        changeCodingListEntryId.mutate({
                            codingListCode: selectedCodingList.id,
                            codingEntryId: initialCodingEntryId,
                            newCodingEntryId: event.target.value,
                            codingEntryLabel: entry.path,
                        }, {
                            onSuccess: () => {
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.SUCCESS,
                                        message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_SUCCESS,
                                    },
                                ]);
                            },
                            onError: error => {
                                logger.error({ error });
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.ERROR,
                                        message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_ERROR,
                                    },
                                ]);
                            },
                            onSettled: () => {
                                setIsMutationInProgress(false);
                            },
                        });
                        initialCodingEntryId = '';
                    },
                },
                entryPath: {
                    text: entry.path,
                    onFocus(event) {
                        // save current entry before changing
                        initialCodingEntryPath = entry.path;
                        if (!currentSelectedEntryValue) {
                            return;
                        }
                        currentSelectedEntryValue.path = event.target.value;
                    },
                    onBlur(event) {
                        if (event.target.value === initialCodingEntryPath) {
                            initialCodingEntryPath = '';
                            return;
                        }
                        setIsMutationInProgress(true);
                        saveCodingListEntry.mutate({
                            codingListCode: selectedCodingList.id,
                            codingEntryId: entry.ID,
                            codingEntryLabel: event.target.value,
                        }, {
                            onSuccess: () => {
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.SUCCESS,
                                        message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_SUCCESS,
                                    },
                                ]);
                            },
                            onError: error => {
                                logger.error({ error });
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.ERROR,
                                        message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_ERROR,
                                    },
                                ]);
                            },
                            onSettled: () => {
                                setIsMutationInProgress(false);
                            },
                        });
                        initialCodingEntryPath = '';
                    },
                },
                rowActions: {
                    tsVariant: 'tsIcon',
                    startIcon: (0, jsx_runtime_1.jsx)("i", { className: "ts-icon-remove ts-color-dark" }),
                    checked: inactiveEntries?.length ? !inactiveEntries.map(e => e.entry_id).includes(entry.ID) : true,
                    onChange(_event, checked) {
                        toggleCodingListEntryQuery.mutate({
                            codingListCode: selectedCodingList.id,
                            codingEntryId: entry.ID,
                            teamId: currentCodingEntryTeam,
                            state: checked,
                        });
                    },
                },
            };
        }),
        isMutationInProgress,
    ];
};
exports.useGetTableData = useGetTableData;
